import cn from 'classnames';

import { IConDefaultType } from '../../types';

export enum FeeIconVariant {
  DEFAULT = 'default',
}
export interface IFeeIconProps extends IConDefaultType {
  variant?: FeeIconVariant;
}

export default function FeeIcon({
  color,
  className,
  size = 20,
  rotate,
  flip,
  variant = FeeIconVariant.DEFAULT,
}: IFeeIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === FeeIconVariant.DEFAULT && (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.5 11.8743L12.5 6.87432M16.25 3.96348V18.1243L13.125 16.8743L10 18.1243L6.875 16.8743L3.75 18.1243V3.96348C3.75 3.04015 4.42167 2.24932 5.33917 2.14265C8.43599 1.78318 11.564 1.78318 14.6608 2.14265C15.5775 2.24932 16.25 3.04015 16.25 3.96348ZM8.125 7.49932H8.13167V7.50598H8.125V7.49932ZM8.4375 7.49932C8.4375 7.5822 8.40458 7.66168 8.34597 7.72029C8.28737 7.77889 8.20788 7.81182 8.125 7.81182C8.04212 7.81182 7.96263 7.77889 7.90403 7.72029C7.84542 7.66168 7.8125 7.5822 7.8125 7.49932C7.8125 7.41644 7.84542 7.33695 7.90403 7.27835C7.96263 7.21974 8.04212 7.18682 8.125 7.18682C8.20788 7.18682 8.28737 7.21974 8.34597 7.27835C8.40458 7.33695 8.4375 7.41644 8.4375 7.49932ZM11.875 11.2493H11.8817V11.256H11.875V11.2493ZM12.1875 11.2493C12.1875 11.3322 12.1546 11.4117 12.096 11.4703C12.0374 11.5289 11.9579 11.5618 11.875 11.5618C11.7921 11.5618 11.7126 11.5289 11.654 11.4703C11.5954 11.4117 11.5625 11.3322 11.5625 11.2493C11.5625 11.1664 11.5954 11.087 11.654 11.0283C11.7126 10.9697 11.7921 10.9368 11.875 10.9368C11.9579 10.9368 12.0374 10.9697 12.096 11.0283C12.1546 11.087 12.1875 11.1664 12.1875 11.2493Z"
            stroke="black"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </i>
  );
}
